export default function Field({ label, children, className = "" }) {
  return (
    <div className={className}>
      <label className="bdx-label block mb-1">{label}</label>
      {children}
    </div>
  );
}
